"use strict";

(function(){
    var self = Fotobook.bottomPanel.carousel = {
        next(e){
            var wrapper = $(e.target).closest('.carousel-navigation').siblings('.bottom-carousel-wrapper');
            var scroll = self.getScroll(wrapper);
            wrapper.data("jsp").scrollBy(scroll);
            self.checkButtons.call(wrapper);
        },

        prev(e){
            var wrapper = $(e.target).closest('.carousel-navigation').siblings('.bottom-carousel-wrapper');
            wrapper.data("jsp").scrollBy(-self.getScroll(wrapper));
            self.checkButtons.call(wrapper);
        },

        selectPage(e){
            var $this = $(e.target).closest(".carousel-item");
            $(e.target).closest(".carousel-list")
                .find(".selected")
                .removeClass("selected")
                .end();
            $this.addClass("selected");
            setTimeout(function(){
                Fotobook.pages.changeCurrent(Fotobook.book.getPageNumFromSpread($this));
            }, 0);
        },

        getWrapperClass() {
            let className = '';
            switch (true) {
                case Fotobook.store.getters['bottomTabs/isActivePhotosTab']:
                    className = 'images-carousel-wrapper';
                    break;
                case Fotobook.store.getters['bottomTabs/isActivePagesTab']:
                    className = 'pages-carousel-wrapper';
                    break;
            }
            return className;
        },

        create(scrolled){
            var $tabs = $("#bottom-tabs"),
                id = Fotobook.store.state.bottomTabs.activeTab,
                scrollPane;

            if (Fotobook.store.getters['bottomTabs/isActivePhotosTab']) {
                // var jsp = $tabs.find(".pages-carousel-wrapper").data("jsp");
                var bookWidthSum = 0;
                $tabs.find(".pages-carousel-wrapper .carousel-item").each(function(){
                    var $this = $(this);
                    bookWidthSum += $this.width() + parseInt($this.css("marginLeft"), 10) + parseInt($this.css("marginRight"), 10);
                });
                $(Fotobook.book.pagesList).width(bookWidthSum);

                // зачем было дестроить, если можно дальше по коду следать ре-инит? непонятно
                // if (jsp) {
                //     jsp.destroy();
                // }
            }
            scrollPane = $tabs.find("." + self.getWrapperClass(id));
            if (!scrollPane.data('jsp')) {
                var options = {
                    "showArrows": true,
                    "animateScroll": true,
                    "maintainPosition": true,
                };
                if ($("html").hasClass("toggle-pages-list-outer")) {
                    $.extend(options, {
                        "alwaysShowVScroll": false, //установлено в false из-за http://bt.web100.com.ua/view.php?id=48442
                        "startScroll": scrolled,
                        "doNotShowHScroll": true,
                    });
                }
                scrollPane.jScrollPane(options);
            } else {
                //реинициализируем скролл панель при изменении размера панели или переключении таба
                scrollPane.data('jsp').reinitialise();
            }
            self.checkButtons.call(scrollPane);

            // запрещаем переставлять местами страницы (стороны) сувенирного продукта
            if (Fotobook.book.product_type.code !== 'souvenir' &&
                Fotobook.store.getters['bottomTabs/isActivePagesTab']
            ) {
                var pgList = $(Fotobook.book.pagesList);
                Fotobook.book.chromeFixCarouselPageWidth();
                self.scrollToSelected();
                pgList.find(".pages-wrapper").filter(":not(.cover,.flyleaf)").closest(".carousel-item").addClass("sortable");
                pgList.sortable({
                    "axis": $("html").hasClass("toggle-pages-list-outer") ? false : "x",
                    "items": ".sortable",
                    "opacity": 0.55,
                    "containment": Fotobook.book.pagesList,
                    "stop": self.sortPages,
                });
            }
        },

        sortPages(event, ui){
            var $pagesList = $(this),
                pageNum = Fotobook.book.product.covers_count,
                attrs = {
                    "pages": {},
                };

            $pagesList.find(".book-page.page").each(function(){
                var pageNumOld = parseInt(this.getAttribute("data-page_num"), 10),
                    $page = $(this);

                if (pageNumOld != pageNum) {
                    var pageId = parseInt(this.getAttribute("data-id"), 10);
                    attrs.pages[pageId] = {
                        "page_num": pageNum,
                    };
                    $page.attr("data-page_num", pageNum);

                    //меняем аттрибут номера для открытой страницы
                    $("#book").find(".book-page[data-id="+pageId+"]").attr("data-page_num", pageNum);

                    if (pageNumOld == Fotobook.store.getters['OnlineEditor/currentPage']) {
                        attrs.current_page = pageNum;
                    }
                }
                pageNum++;
            });

            //обновляем подпись под страницами
            $pagesList.find(".page_num").each(function(){
                self.updatePageNum($(this));
            });

            //Устанавливаем текущую страницу для корректного отображения в предпросмотре
            Fotobook.store.dispatch(
                'OnlineEditor/setCurrentPage',
                Fotobook.book.getPageNumFromSpread($(Fotobook.book.pagesList).find(".carousel-item.selected .book"))
            );

            // Fotobook.pages.updatePageNumbers();

            if (Object.keys(attrs.pages).length) {
                $pagesList.sortable("disable");
                Fotobook.pages.changePageAttrs(attrs).catch(()=>null).finally(() => {
                    $pagesList.sortable("enable");

                    Fotobook.store.dispatch('bottomPanel/afterSortable');
                    // Fotobook.bottomPanel.pagesTab.afterSortable();
                });
            }
        },

        /* pageNumElement - Fotobook.book.pagesList + " .page_num" */
        updatePageNum(pageNumElement){
            var names = [],
                page_name;
            pageNumElement.closest(".carousel-item").find(".book-page").each(function () {
                var str = Fotobook.pages.getPrintPageNum($(this));
                if (str) {
                    names.push(str);
                }
            });
            page_name = names.join(" &mdash; ");
            pageNumElement.html(page_name);
            //Отображать название страниц при наведении мышкой если они не полностью отображаются в нижней панели Страницы в редакторе
            pageNumElement.addClass('ajax-tooltip').attr("data-qtip-text", page_name);
        },

        getScroll($wrapper){
            var scroll;
            if ($wrapper.hasClass("images-carousel-wrapper")) {
                var element = $wrapper.find('.one-lines-items:visible, .two-lines-items:visible');
                scroll = element.find('.outer').width() * 2;
            } else {
                scroll = $wrapper.find(".carousel-item").width();
            }
            return scroll;
        },
        async checkButtons() {
            var wrapper = $(this),
                jsp = wrapper.data("jsp"),
                $prev = wrapper.siblings(".carousel-navigation.carousel-prev"),
                $next = wrapper.siblings(".carousel-navigation.carousel-next"),
                percent;

            if (!jsp) {
                return;
            }
            if (wrapper.hasClass('images-carousel-wrapper')) {
                await Fotobook.store.dispatch('bottomPanel/setScrolled', jsp.getContentPositionX());
                // Fotobook.bottomPanel.scrolled = jsp.getContentPositionX();
            }
            percent = jsp.getPercentScrolledX();
            $next.toggleClass("disabled", jsp.getContentWidth() < wrapper.width());
            if (percent == 0) {
                $prev.addClass("disabled");
            } else if (percent > 0 && percent < 0.99) {
                $prev.removeClass("disabled");
                $next.removeClass("disabled");
            } else if (percent == 1) {
                $prev.removeClass("disabled");
                $next.addClass("disabled");
            } else {
                $prev.removeClass("disabled");
                $next.addClass("disabled");
            }
        },

        scrollToSelected(){
            var carousel = $(".pages-carousel-wrapper:visible"),
                jsp = carousel.data("jsp"),
                offset = 0,
                $pages, $selected;

            if (!jsp)
                return;

            $pages = $(Fotobook.book.pagesList);
            $selected = $pages.find(".carousel-item.selected");
            if (!$selected.length) {
                $selected = Fotobook.book.getPageByPageNum(
                    Fotobook.store.getters['OnlineEditor/currentPage']
                );
                if (!$selected.length) {
                    $selected = $pages.find(".book-page:not(.flyleaf-page)");
                }
                if ($selected.length) {
                    $selected = $selected.closest(".carousel-item");
                } else {
                    $selected = $pages.find(".carousel-item").first();
                }
            }
            if ($selected.length) {
                var rect = $selected[0].getBoundingClientRect(),
                    left = $(".carousel-prev")[0].getBoundingClientRect().right,
                    right = $(".carousel-next")[0].getBoundingClientRect().left;

                if (rect.left < left || rect.right > right) {
                    offset = $selected.position().left;
                    jsp.scrollToX(offset - (carousel.width() / 2), false);
                }
            }
        },
    };

    $(document)
    .on("click", ".carousel-next", self.next)
    .on("click", ".carousel-prev", self.prev)
    .on("click", ".carousel-pages-list .carousel-item:not(.selected) .book", self.selectPage)
    .on("scroll", ".bottom-carousel-wrapper", self.checkButtons)
    ;

    // на этапе загрузки скрипта ещё нет body, из-за этого получаем ошибку
    $(function(){
        $(document)
        .on("mousewheel", ".bottom-carousel-wrapper", function(event, delta, deltaX, deltaY){
            var api = $(this).data("jsp");
            if (api){
                // disable browser scrolling
                event.preventDefault();
                api.scrollByX(-100 * delta);
            }
        })
    });
})();
